<template>
    <div>
        <import-form
            subject="Customers"
            v-model="importModal"
            @cancel="hideModal()"
            :fields="customerFields"
            :upload-record="uploadCustomerRecord"
            settings-key-name="customerUploadKey"
        ></import-form>

        <customer-table
            title="Warehouse"
            ref="customertableRef"
            @report-state="loading = $event"
        >
            <page-actions
                :buttons-actions="buttonActions"
                control-class="float-right"
                control-size="sm"
            />
        </customer-table>
    </div>
</template>
<script>
import CustomerTable from './CustomerTable'
import ImportForm from '@/components/ImportForm.vue'

import PageActions from '@/components/PageActions.vue'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

const customerFields = [
    { name: 'code', required: true, type: 'text' },
    { name: 'name', required: true, type: 'text' },
    { name: 'email', required: false, type: 'email' },
    { name: 'address1', required: false, type: 'text' },
    { name: 'address2', required: false, type: 'text' },
    { name: 'city', required: false, type: 'text' },
    { name: 'country_code', required: false, type: 'text' },
]

export default {
    name: 'customers',
    components: {
        CustomerTable,
        ImportForm,
        PageActions,
    },
    mixins: [popupMixins, permissionsMixins],
    data: () => {
        return {
            componentName:'Customer',
            loading: false,
            importModal: false,
            customerFields,
        }
    },
    computed: {
        buttonActions() {
            const actions = []
            if (this.hasPermissionCreate) {
                actions.push(
                    {
                        action: () => this.createNewOrder(),
                        icon: 'plus-circle',
                        variant: 'light',
                        tooltip: 'Create New Customer',
                    },
                    {
                        action: () => this.importOrders(),
                        icon: 'upload',
                        variant: 'light',
                        tooltip: 'Import Customers',
                    }
                )
            }
            if (this.hasPermissionView) {
                actions.push({
                    action: () => this.exportContacts(),
                    icon: 'download',
                    variant: 'light',
                    tooltip: 'Export Customers',
                })
            }
            return actions
        },
    },

    methods: {
        createNewOrder() {
            const id = 0
            this.$router.push({ params: { id }, name: 'viewCustomer' })
        },
        importOrders() {
            this.importModal = true
        },
        hideModal() {
            this.$refs.customertableRef.doSearch()
        },

        customerCreated() {
            this.genericToast(this.componentName,'Created','success','Customer successfully created')
            // this.doToast('Customer Action!', 'Customer Created.', 'success')
            this.$refs.customertableRef.doSearch()
        },
        customerImported() {
            this.genericToast(this.componentName,'Imported','success','Customers successfully imported')
            // this.doToast('Customer Action!', 'Customer Imported.', 'success')
            this.$refs.customertableRef.doSearch()
        },
        exportContacts() {
            this.$refs.customertableRef.generateReport()
        },
        async uploadCustomerRecord(
            dataRecord,
            statusRecord,
            check,
            statuses,
            setLoading
        ) {
            let { code, name, email, address1, address2, city, country_code } =
                dataRecord
            let res = null
            statusRecord.status = statuses.CHECKING
            if (check == 1) {
                city = city || 'Kingston'
                country_code = country_code || 'JM'
                let location = { address1, address2, city, country_code }
                console.log('netering ')
                setLoading(true)
                // try to find the location

                try {
                    statusRecord.status = statuses.GEOCODING
                    const { latitude, longitude } = await this.$store.dispatch(
                        'locations/geocodeAddress',
                        location
                    )
                    console.log('geocode', { latitude, longitude })
                    location = { ...location, ...{ latitude, longitude } }
                    statusRecord.status = statuses.SAVING
                    // try to upload order with location
                    res = await this.$store.dispatch(
                        'customers/uploadCustomer',
                        {
                            code,
                            name,
                            email,
                            location,
                        }
                    )

                    // set status to complete if the upload was successful
                    if (res.status_code == 200) {
                        statusRecord.status = statuses.COMPLETE
                    } else {
                        // add errors to error list and set error status if upload failed
                        statusRecord.error_list =
                            typeof res.message == 'string'
                                ? [['error', [res.message]]]
                                : Object.entries(res.message)
                        statusRecord.status = statuses.ERROR
                    }
                } catch (err) {
                    console.warn(err)
                    //try to upload order without location
                    res = await this.$store.dispatch(
                        'customers/uploadCustomer',
                        {
                            code,
                            name,
                            email,
                            location,
                        }
                    )

                    // set status to complete with a warning if the upload was successful
                    if (res.status_code == 200) {
                        statusRecord.status = statuses.INVALID_LOCATION
                    } else {
                        statusRecord.error_list =
                            typeof res.message == 'string'
                                ? [['error', [res.message]]]
                                : Object.entries(res.message)
                        statusRecord.status = statuses.ERROR
                    }
                } finally {
                    setLoading(false)
                }
            } else {
                // set error status if the name or email fails validation
                statusRecord.status = statuses.ERROR
                if (check == 0) {
                    statusRecord.error_list = [['name', ['Invalid name']]]
                }
                if (check == -1) {
                    statusRecord.error_list = [
                        ['email', ['Invalid email format']],
                    ]
                }
            }
        },
    },
}
</script>
<style></style>
